import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/product/kyc-api/Banner-Identification.png';
import _imports_1 from '@/assets/product/kyc-api/ID-card.png';
import _imports_2 from '@/assets/product/duihao.png';
import _imports_3 from '@/assets/product/kyc-api/Passport.png';
import _imports_4 from '@/assets/product/kyc-api/Driving-license.png';
import _imports_5 from '@/assets/product/kyc-api/Bank-card.png';
import _imports_6 from '@/assets/product/kyc-api/Financial-institutions.png';
import _imports_7 from '@/assets/product/kyc-api/Telecommunication.png';
import _imports_8 from '@/assets/product/kyc-api/Gaming.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-26a481b4"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "kyc"
};
var _hoisted_2 = {
  class: "banner"
};
var _hoisted_3 = {
  class: "content"
};
var _hoisted_4 = {
  class: "banner-text animate__animated animate__fadeInLeft"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "Identity Verification Solution", -1);
});

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "info"
  }, [/*#__PURE__*/_createTextVNode("Reduce your KYC and compliance risks and"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" costs with our intelligent services")], -1);
});

var _hoisted_7 = /*#__PURE__*/_createTextVNode("COMING SOON");

var _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"platform\" data-v-26a481b4><div class=\"project-title animate__animated animate__fadeInUp wow\" data-v-26a481b4>Solutions We Offered</div><div class=\"item animate__animated animate__fadeInUp wow\" data-v-26a481b4><div class=\"left\" data-v-26a481b4><img src=\"" + _imports_1 + "\" alt=\"ID card\" title=\"ID card\" data-v-26a481b4></div><div class=\"right right-margin\" data-v-26a481b4><div class=\"title\" data-v-26a481b4>National ID Verification</div><div class=\"list\" data-v-26a481b4><div class=\"list-item\" data-v-26a481b4><div class=\"mr-5\" data-v-26a481b4><img src=\"" + _imports_2 + "\" data-v-26a481b4>Name</div><div data-v-26a481b4><img src=\"" + _imports_2 + "\" data-v-26a481b4>ID Number</div></div><div class=\"list-item\" data-v-26a481b4><div class=\"mr-5\" data-v-26a481b4><img src=\"" + _imports_2 + "\" data-v-26a481b4>Date of Birth</div><div data-v-26a481b4><img src=\"" + _imports_2 + "\" data-v-26a481b4>Authenticity</div></div><div class=\"list-item\" data-v-26a481b4><div class=\"mr-5\" data-v-26a481b4><img src=\"" + _imports_2 + "\" data-v-26a481b4>ID Status</div><div data-v-26a481b4></div></div></div></div></div><div class=\"item animate__animated animate__fadeInUp wow\" data-v-26a481b4><div class=\"left\" data-v-26a481b4><div class=\"title\" data-v-26a481b4>Passport Verification</div><div class=\"list\" data-v-26a481b4><div class=\"list-item\" data-v-26a481b4><div class=\"mr-5\" data-v-26a481b4><img src=\"" + _imports_2 + "\" data-v-26a481b4>Name</div><div data-v-26a481b4><img src=\"" + _imports_2 + "\" data-v-26a481b4>Passport Number</div></div><div class=\"list-item\" data-v-26a481b4><div class=\"mr-5\" data-v-26a481b4><img src=\"" + _imports_2 + "\" data-v-26a481b4>Authenticity</div><div data-v-26a481b4></div></div></div></div><div class=\"right\" data-v-26a481b4><img src=\"" + _imports_3 + "\" alt=\"Passport\" title=\"Passport\" data-v-26a481b4></div></div><div class=\"item animate__animated animate__fadeInUp wow\" data-v-26a481b4><div class=\"left\" data-v-26a481b4><img src=\"" + _imports_4 + "\" alt=\"Driving license\" title=\"Driving license\" data-v-26a481b4></div><div class=\"right right-margin\" data-v-26a481b4><div class=\"title\" data-v-26a481b4>Driving License Verification</div><div class=\"list\" data-v-26a481b4><div class=\"list-item\" data-v-26a481b4><div class=\"mr-5\" data-v-26a481b4><img src=\"" + _imports_2 + "\" data-v-26a481b4>Name</div><div data-v-26a481b4><img src=\"" + _imports_2 + "\" data-v-26a481b4>License Number</div></div><div class=\"list-item\" data-v-26a481b4><div class=\"mr-5\" data-v-26a481b4><img src=\"" + _imports_2 + "\" data-v-26a481b4>License Status</div><div data-v-26a481b4><img src=\"" + _imports_2 + "\" data-v-26a481b4>License Type</div></div><div class=\"list-item\" data-v-26a481b4><div class=\"mr-5\" data-v-26a481b4><img src=\"" + _imports_2 + "\" data-v-26a481b4>Date of issue</div><div data-v-26a481b4><img src=\"" + _imports_2 + "\" data-v-26a481b4>Authenticity</div></div></div></div></div><div class=\"item animate__animated animate__fadeInUp wow\" data-v-26a481b4><div class=\"left\" data-v-26a481b4><div class=\"title\" data-v-26a481b4>Bank Card Verification</div><div class=\"list\" data-v-26a481b4><div class=\"list-item\" data-v-26a481b4><div class=\"mr-5\" data-v-26a481b4><img src=\"" + _imports_2 + "\" data-v-26a481b4>Name</div><div data-v-26a481b4><img src=\"" + _imports_2 + "\" data-v-26a481b4>Bank Card Number</div></div><div class=\"list-item\" data-v-26a481b4><div class=\"mr-5\" data-v-26a481b4><img src=\"" + _imports_2 + "\" data-v-26a481b4>Authenticity</div></div></div></div><div class=\"right\" data-v-26a481b4><img src=\"" + _imports_5 + "\" alt=\"Bank card\" title=\"Bank card\" data-v-26a481b4></div></div></div><div class=\"technical animate__animated animate__fadeInUp wow\" data-v-26a481b4><div class=\"project-title\" data-v-26a481b4>Who Need US</div><div class=\"content\" data-v-26a481b4><div class=\"item\" data-v-26a481b4><img src=\"" + _imports_6 + "\" alt=\"Financial service\" title=\"Financial service\" data-v-26a481b4><div class=\"text\" data-v-26a481b4>Financial Services</div></div><div class=\"item\" data-v-26a481b4><img src=\"" + _imports_7 + "\" alt=\"Signal Tower\" title=\"Telecommunication\" data-v-26a481b4><div class=\"text\" data-v-26a481b4>Telecommunication</div></div><div class=\"item\" data-v-26a481b4><img src=\"" + _imports_8 + "\" alt=\"Game controller\" title=\"Gaming\" data-v-26a481b4><div class=\"text\" data-v-26a481b4>Gaming</div></div></div></div>", 2);

import Number from '@/components/Number/index.vue';
import Footer from '@/components/Footer/index.vue';
import { useRoute } from 'vue-router';
import setMeta from '@/utils/metaUtils';
import { ref, getCurrentInstance, onMounted } from 'vue';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var _getCurrentInstance;

    var global = (_getCurrentInstance = getCurrentInstance()) === null || _getCurrentInstance === void 0 ? void 0 : _getCurrentInstance.appContext.config.globalProperties;
    var numberRef = ref();
    var route = useRoute();
    setMeta(route);
    var options = ref([{
      num: 1.5,
      label: 'Billion',
      text: 'National ID'
    }, {
      num: 180,
      label: 'Million',
      text: 'Passport'
    }, {
      num: 469,
      label: 'Million',
      text: 'Driving License'
    }]);

    function getImg() {
      numberRef.value.play();
    }

    onMounted(function () {
      global.$wow.init();
    });
    return function (_ctx, _cache) {
      var _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        alt: "Facial recognition",
        title: "Intelligent identification",
        src: _imports_0,
        onLoad: _cache[0] || (_cache[0] = function ($event) {
          return getImg();
        })
      }, null, 32), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _hoisted_6, _createVNode(_component_el_button, {
        class: "banner-btn",
        disabled: ""
      }, {
        default: _withCtx(function () {
          return [_hoisted_7];
        }),
        _: 1
      })])])]), _createVNode(Number, {
        options: options.value,
        ref_key: "numberRef",
        ref: numberRef,
        class: "animate__animated animate__fadeInUp"
      }, null, 8, ["options"]), _hoisted_8, _createVNode(Footer)]);
    };
  }
});